import { useState } from "react"
import { OverlayTrigger, Popover } from "react-bootstrap"

export const ClickToEditInput = ({ type, value, setValue, reset, modeOverride, editModeTooltip, readonlyModeTooltip }) => {
    const [isLocallyEditing, setIsLocallyEditing] = useState(false)
    const isInEditMode = modeOverride || isLocallyEditing

    return (
        <div className="input-group px-0">
            <input onClick={ () => setIsLocallyEditing(true) } readOnly={ !isInEditMode } className={ `form-control ${ isInEditMode ? "cursor-normal" : "cursor-pointer" }` } value={ value } type={ type } onChange={ (e) => setValue(e.target.value) } />
            <OverlayTrigger
                trigger="hover"
                placement='top'
                overlay={ <Popover className="p-1 click-to-edit-popover">
                    <Popover.Body>{ isInEditMode ? editModeTooltip : readonlyModeTooltip }</Popover.Body>
                </Popover> }
            >
                <div className="input-group-append">
                    <button
                        style={ { height: "34px" } }
                        className="btn btn-falcon-default btn-sm py-0"
                        onClick={ () => {
                            if (isInEditMode) {
                                reset(); setIsLocallyEditing(false);
                            } else {
                                setIsLocallyEditing(true)
                            }
                        } }
                    >
                        { isInEditMode && <i className="fas fa-undo m-0"></i> }
                        { !isInEditMode && <i className="fas fa-edit m-0"></i> }
                    </button>
                </div>
            </OverlayTrigger>
        </div>
    )
}
